import { Box, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material"

import { useThemeMode } from "../../hooks/useThemeMode"

import { strings } from "../../config/strings"
import { DarkMode, LightMode, SettingsBrightness } from "@mui/icons-material"


export const ThemeSelector = () => {

    const { 
        getCurrentMode, 
        setCurrentMode 
    } = useThemeMode()

    const themeChangeHandle = (_: React.MouseEvent<HTMLElement>, value: 'dark' | 'system' | 'light' | null) => {
        
        if(value === null) 
            return
        
        if(value === 'system') {
            if(window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
                setCurrentMode('dark')
            }
            else {
                setCurrentMode('light')
            }
        }
        else {
            setCurrentMode(value)
        }
    }

    return (
        <Box sx={{p:1}}>
            <Typography variant="overline" component={Box}>{strings.mode}</Typography>
            <ToggleButtonGroup 
                exclusive
                fullWidth
                value={getCurrentMode()} 
                size="small" 
                onChange={themeChangeHandle}>
                    <ToggleButton value={'dark'}><DarkMode fontSize='small'/></ToggleButton>
                    <ToggleButton value={'system'}><SettingsBrightness fontSize='small'/></ToggleButton>
                    <ToggleButton value={'light'}><LightMode fontSize='small'/></ToggleButton>
            </ToggleButtonGroup>    
        </Box>
    )
}